// Constants every form on the site shares — the contact form, the delete-account page and the
// join-school invite page. Each page declared its own byte-identical copy of these before this
// module existed, so a wording change had to be made in three places to take effect.

// Client-side email shape check. Deliberately loose — it catches an obvious typo before a round
// trip; the API re-validates authoritatively and its answer is the one that decides.
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Shown when the server answered but sent no message of its own to display.
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again later.'

// Shown when the request never reached a server at all.
export const NETWORK_ERROR_MESSAGE = 'Unable to reach the server. Please check your connection and try again.'
